import {ILocationProvider} from "angular";

/* @ngInject */
export const html5Mode = ($locationProvider: ILocationProvider) => {
    $locationProvider.html5Mode(true);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/config/html5-mode.config.ts